export const retryWithBackoff = async <T>(
    fn: () => Promise<T>,
    {
        maxAttempts,
        baseMs,
        shouldRetry,
    }: { maxAttempts: number; baseMs: number; shouldRetry: (result: T) => boolean }
): Promise<T> => {
    let result: T
    for (let attempt = 0; attempt < maxAttempts; attempt++) {
        result = await fn()
        if (!shouldRetry(result)) return result
        const backoff = baseMs * 2 ** attempt + Math.floor(Math.random() * baseMs)
        await new Promise((resolve) => setTimeout(resolve, backoff))
    }
    return result!
}
